<template>
  <form novalidate="true" autocomplete="off" @submit.prevent>
    <slot />
  </form>
</template>

<script>
import get from "lodash/get";
import bus from "@/bus";

export default {
  name: "FormValidator",
  props: {
    analyticsSubmodule: String
  },
  data() {
    return {
      elements: [],
      mountedElements: [],
      checkedUids: [],
      validForm: null
    };
  },
  mounted() {
    bus.$on("formValidate", this.autoValidate);
  },
  updated() {
    if (this.validForm !== null) {
      this.autoValidate();
    }
  },
  methods: {
    gtmName(element) {
      return get(element, "$options.propsData.name", this.$options.name);
    },
    gtmError(element) {
      let error = get(element, "error", undefined);
      if (typeof error === "string" && error.length) {
        return error;
      }
      let validationError = get(element, "$data.validationError", undefined);
      let the_error = null;
      if (typeof validationError !== "string") {
        Object.keys(validationError).forEach(key => {
          if (Object.hasOwn(validationError, key)) {
            if (validationError[key] !== null) {
              the_error = validationError[key];
              return;
            }
          }
        });
      }
      return the_error || validationError;
    },
    elementName(element) {
      return get(
        element,
        "$options.propsData.analyticsName",
        get(element, "$options.propsData.name", this.$options.name)
      );
    },
    elementAnalyticsTypology(element) {
      return get(element, "$options.propsData.analyticsTypology", "solicitud");
    },
    refreshMountedElements() {
      this.checkedUids = [];
      this.mountedElements = this.elements.filter(el => {
        // Filtrar todos los elementos que no estan "destruidos"
        return !el._isDestroyed;
      });
    },
    autoValidate() {
      this.validForm = this.mountedElements.every(element => {
        if (!element.checkValid) {
          this.$log.error(
            "No se implementó la función checkValid en el elemento: " +
              element.$options.name
          );
          // Los elementos que no tienen checkValid se asumen
          // válidos
          return true;
        }
        return element.checkValid();
      });
    },
    validate() {
      this.refreshMountedElements();
      let validForm = true;

      for (let element of this.mountedElements) {
        // Valido si el elemento suscrito tiene validador
        if (!element.checkValid) {
          this.$log.error(
            "No se implementó la función checkValid en el elemento: " +
              element.$options.name
          );
          continue;
        }

        // Ejecuto validador
        if (element.checkValid()) {
          // El elemento valida correctamente
          // no es necesario hacer nada más
          continue;
        }

        // El elemento no es válido, hay error en el form
        validForm = false;
        const isNotFormValidator =
          this.elementName(element) !== "FormValidator";

        if (isNotFormValidator && !this.checkedUids.includes(element._uid)) {
          this.checkedUids.push(element._uid);
        }
      }

      this.validForm = validForm;
      return validForm;
    },
    subscribe(el) {
      this.elements.push(el);
    }
  }
};
</script>
